import { affiliateServices } from "../../../../services";
import {
  FETCH_AFFILIATE_DASHBOARD_INIT,
  FETCH_AFFILIATE_DASHBOARD,
  FETCH_AFFILIATE_DASHBOARD_SIX_MONTH,
  FETCH_AFFILIATE_DASHBOARD_DATA,
  FETCH_AFFILIATE_RESERVATIONS,
  TOAST,
} from "../../../types/affiliateDashboard.type";

export const initializeAffiliateDashboardScreen = () => ({
  type: FETCH_AFFILIATE_DASHBOARD_INIT,
});

export const affiliateDashboardFetchStart = () => ({
  type: FETCH_AFFILIATE_DASHBOARD.START,
});

export const affiliateDashboardFetchSuccess = (payload) => ({
  type: FETCH_AFFILIATE_DASHBOARD.SUCCESS,
  payload,
});

export const affiliateDashboardFetchError = (payload) => ({
  type: FETCH_AFFILIATE_DASHBOARD.ERROR,
  payload,
});

export const resetToast = () => ({
  type: TOAST.RESET,
});

export const affiliateDashboardSixMonthFetchStart = () => ({
  type: FETCH_AFFILIATE_DASHBOARD_SIX_MONTH.START,
});

export const affiliateDashboardSixMonthFetchSuccess = (payload) => ({
  type: FETCH_AFFILIATE_DASHBOARD_SIX_MONTH.SUCCESS,
  payload,
});

export const affiliateDashboardSixMonthFetchError = (payload) => ({
  type: FETCH_AFFILIATE_DASHBOARD_SIX_MONTH.ERROR,
  payload,
});

export const fetchAffiliateDashboardSixMonth = (payload = {}) => {
  return (dispatch) => {
    dispatch(affiliateDashboardSixMonthFetchStart());
    affiliateServices.fetchAffiliateDashboard({ ...payload, period: 180 }).then((data) => {
      if (!data.isError) {
        dispatch(affiliateDashboardSixMonthFetchSuccess(data));
      } else {
        dispatch(affiliateDashboardSixMonthFetchError(data));
      }
    });
  };
};

export const affiliateDashboardDataFetchStart = () => ({
  type: FETCH_AFFILIATE_DASHBOARD_DATA.START,
});

export const affiliateDashboardDataFetchSuccess = (payload) => ({
  type: FETCH_AFFILIATE_DASHBOARD_DATA.SUCCESS,
  payload,
});

export const affiliateDashboardDataFetchError = (payload) => ({
  type: FETCH_AFFILIATE_DASHBOARD_DATA.ERROR,
  payload,
});

export const fetchAffiliateDashboardData = (payload = {}) => {
  return (dispatch) => {
    dispatch(affiliateDashboardDataFetchStart());
    affiliateServices.fetchAffiliateDashboardData(payload).then((data) => {
      if (!data.isError) {
        dispatch(affiliateDashboardDataFetchSuccess(data));
      } else {
        dispatch(affiliateDashboardDataFetchError(data));
      }
    });
  };
};

export const affiliateReservationsFetchStart = (payload) => ({
  type: FETCH_AFFILIATE_RESERVATIONS.START,
  payload,
});

export const affiliateReservationsFetchSuccess = (payload) => ({
  type: FETCH_AFFILIATE_RESERVATIONS.SUCCESS,
  payload,
});

export const affiliateReservationsFetchError = (payload) => ({
  type: FETCH_AFFILIATE_RESERVATIONS.ERROR,
  payload,
});

export const fetchAffiliateReservations = (payload = {}) => {
  return (dispatch) => {
    dispatch(affiliateReservationsFetchStart({ affiliateId: payload.affiliateId }));
    affiliateServices.fetchAffiliateReservations(payload).then((data) => {
      if (!data.isError) {
        dispatch(affiliateReservationsFetchSuccess({ ...data, affiliateId: payload.affiliateId }));
      } else {
        dispatch(affiliateReservationsFetchError({ ...data, affiliateId: payload.affiliateId }));
      }
    });
  };
};

export const fetchAffiliateDashboard = (payload = {}) => {
  return (dispatch) => {
    dispatch(affiliateDashboardFetchStart());
    affiliateServices.fetchAffiliateDashboard(payload).then((data) => {
      if (!data.isError) {
        dispatch(affiliateDashboardFetchSuccess(data));
      } else {
        dispatch(affiliateDashboardFetchError(data));
      }
    });
  };
};
